module.exports = __webpack_public_path__ + "img/9788995547298.1216b3da.jpg";